import styled from 'styled-components';

const Container = styled.div`
  position: relative;
  background-color: ${({ backgroundColor }) => `var(${backgroundColor})`};
  .carousel--heading {
    font-family: var(--font-family-heading);
    font-weight: var(--font-weight-900);
    text-align: center;
    color: var(--darkest);
    margin: 60px 0 10px;
    padding: 0 28px;
  }
  .carousel--subhead {
    text-align: center;
    margin: 0 auto;
    padding: 0 28px;
    max-width: 900px;
  }
  .slick-prev,
  .slick-next {
    z-index: 1;
    display: flex !important;
    background: white;
    height: 60px;
    width: 60px;
    justify-content: center;
    border-radius: 50%;
    align-items: center;
    bottom: -50px;
    top: auto;
    &:before {
      content: '';
    }
  }
  .slick-dots {
    bottom: 0px;
  }
  .slick-dots li button {
    &:before {
      font-size: var(--font-size-13);
    }
    &:focus {
      &:before {
        opacity: 0.25;
      }
    }
    @media (min-width: 768px) {
      &:hover {
        &:before {
          color: var(--titan-blue-3);
          opacity: 0.85;
        }
      }
    }
  }
  .slick-dots li.slick-active button {
    &:before {
      color: var(--titan-blue-3);
      opacity: 1;
    }
  }
  .slick-prev {
    left: 30%;
  }
  .slick-next {
    right: 30%;
  }
  @media (max-width: 1000px) {
    .slick-prev {
      left: 25%;
    }
    .slick-next {
      right: 25%;
    }
  }
  ${({ includesFullWidthBackground }) => {
    if (includesFullWidthBackground) {
      return `
        .row-container--container {
          padding-bottom: 190px;
        }
        .slick-prev, .slick-next {
          bottom: 40px;
        }
        .slick-dots {
          bottom: 85px;
        }
      `;
    }
  }}
  @media (max-width: 767px) {
    .slick-dots {
      bottom: 10px;
    }
    .slick-prev,
    .slick-next {
      height: 40px;
      width: 40px;
      bottom: -20px;
      img {
        height: 40px;
        width: 40px;
      }
    }
    .slick-prev {
      left: 25px;
    }
    .slick-next {
      right: 25px;
    }
    ${({ includesFullWidthBackground }) => {
      if (includesFullWidthBackground) {
        return `
        .row-container--container {
          padding-bottom: 140px;
        }
        .slick-prev, .slick-next {
          bottom: 40px;
        }
        .slick-dots {
          bottom: 67px;
        }
      `;
      }
    }}
  }
  ${({ versionStyling }) => {
    if (versionStyling === 'V1') {
      return `
        .slick-track {
          display: flex;
        }

        .slick-slide {
          height: auto !important;
          display: flex !important;
          align-items: stretch;

          & > div {
            width: 100%;
          }

          .section-container {
            height: 100%;

            .styles-container {
              height: 100%;
            }
          }
        }
      `;
    }
    if (versionStyling === 'V2') {
      return `
        margin: 0 auto;
        
        .slick-slide {
          z-index: 0;
        }
        .slick-slide.slick-active {
          z-index: 100;
        }
        .carousel--heading {
          font-family: var(--font-family-heading);
          font-weight: var(--font-weight-900);
          margin: 60px 0 45px 0;
        }
        .section-container-row {
          margin: 0 0 35px 0 !important;
        }
        @media (max-width: 991px) {
          .section-container-row {
            margin: 0;
          }
        }

        @media (max-width: 575px) {
          .carousel--heading {
            font-size: var(--font-size-28);
            margin: 60px auto 25px auto;
          }
        }
        @media (max-width: 480px) {
          .carousel--heading {
            max-width: 350px;
          }
        }
      `;
    }
    if (versionStyling === 'V3') {
      return `
        margin-bottom: 75px;
        .carousel--heading {
          font-family: var(--font-family-heading);
          font-weight: var(--font-weight-900);
          margin: 60px 0px 20px;
        }
        .styles-container > .section-container-row {
          margin: 40px 0px;
        }
        @media (max-width: 575px) {
          margin-bottom: 40px;
          .carousel--heading {
            padding: 0 56px;
          }
        }
      `;
    }
    if (versionStyling === 'V5') {
      return `
        .slick-slide > div, .slick-track {
          height: 100%;
        }
        @media (min-width: 576px) {
          .slick-slide {
            > div {
              margin-right: 40px;
            }
          }
          .slick-list {
            overflow: visible;
            margin-right: -40px;
          }
          .slick-slider {
            padding: 0 28px;
            margin: 0 auto 12px;
          }
        }
        @media (min-width: 1296px) {
          .slick-slider {
            max-width: var(--max-width);
          }
        }
        @media (max-width: 575px) {
          .carousel--heading {
            display: none;
          }
          .slick-list {
            height: auto !important;
          }
          .slick-slider {
            margin-top: 55px;
          }
        }
      }
      `;
    }
    if (versionStyling === 'Bender') {
      return `
        .slick-dots {
          left: 50%;
          transform: translateX(-50%);
          margin-bottom: 90px;
          max-width: 1336px;
          padding: 0 28px;
          display: flex !important;
          justify-content: flex-end;
          gap: 0 5px;
          pointer-events: none;
          z-index: 500;

          li {
            margin: 0;
            pointer-events: all;
          }

          @media (max-width: 767px) {
            padding: 0 20px;
            margin-bottom: 50px;
          }

          @media (max-width: 575px) {
            margin-bottom: 20px;
          }
        }
      `;
    }
  }}
`;

export { Container };
